import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/";
import {
  AlertService,
  AreaSectorOfBusinessService,
  AppService,
} from "../_services/index";
import {
  NgbModal,
  NgbActiveModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";

class AreaSectorOfBusiness {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: "app-area-sector-of-business",
  templateUrl: "./area-sector-of-business.component.html",
  styles: [],
})
export class AreaSectorOfBusinessComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [5], orderable: false }],
  };
  dtTrigger = new Subject();

  areaSectorOfBusinessList: AreaSectorOfBusiness[] = []; // Table Data list
  isSubmitted = false;
  getAreaSectorOfBusiness = {
    id: "",
    name: "",
    description: "",
    is_active: "N",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;

  constructor(
    public router: Router,
    private dataService: AreaSectorOfBusinessService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) {}

  areasectorofbusiness = {
    id: "",
    name: "",
    description: "",
    is_active: "Y",
  };
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);

    this.allAreaSectorOfBusiness();
  }

  allAreaSectorOfBusiness() {
    this.loadShow();
    this.dataService
      .getAllAreaSectorOfBusiness()
      .pipe()
      .subscribe((data) => {
        this.areaSectorOfBusinessList = data["AreaSectorOfBusiness"];
        this.rerender();
        this.loadHide();
      });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  open(content) {
    this.isSubmitted = false;
    this.areasectorofbusiness.id = "";
    (this.areasectorofbusiness.name = ""),
      (this.areasectorofbusiness.description = ""),
      (this.areasectorofbusiness.is_active = "Y");
    this.modalTitle = "Add Area Sector Of Business";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  edit(id, content) {
    this.loadShow();
    this.dataService
      .areaSectorOfBusinessEdit(id)
      .pipe()
      .subscribe((data) => {
        this.getAreaSectorOfBusiness = data["AreaSectorOfBusiness"];
        this.areasectorofbusiness = {
          id: this.getAreaSectorOfBusiness.id,
          name: this.getAreaSectorOfBusiness.name,
          description: this.getAreaSectorOfBusiness.description,
          is_active: this.getAreaSectorOfBusiness.is_active,
        };
        this.loadHide();
        this.modalTitle = "Edit Area Sector Of Business";
        this.modalReference = this.modalService.open(content, {
          backdrop: "static",
          keyboard: false,
        });
      });
  }

  save(val, f) {
    this.isSubmitted = true;
    this.isSubmitted = true;
    if (this.isFieldsInvalid(this.areasectorofbusiness.name)) {
      return;
    }
    if (f.form.valid) {
      this.loadShow();
      if (val.id == "") {
        this.dataService
          .save(this.areasectorofbusiness)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success(
                "Area sector of business saved successfully",
                true
              );
              this.allAreaSectorOfBusiness();
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            }
          );
      } else {
        this.dataService
          .areaSectorOfBusinessUpdate(this.areasectorofbusiness)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success(
                "Area sector of business updated successfully",
                true
              );
              this.allAreaSectorOfBusiness();
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            }
          );
      }
    }
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .areaSectorOfBusinessDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Area sector of business deleted successfully",
              true
            );
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            this.allAreaSectorOfBusiness();
          } else {
            this.alertService.error("Area sector of business error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
